import styled from 'styled-components';
import { theme } from '../styles/theme';

export const FiltersContainer = styled.div`
  background: ${theme.colors.background.primary};
  padding: ${theme.spacing[5]};
  border-radius: ${theme.borderRadius.xl};
  box-shadow: ${theme.shadows.sm};
  margin-bottom: ${theme.spacing[5]};
  display: flex;
  gap: ${theme.spacing[4]};
  align-items: center;
  flex-wrap: wrap;
`;

export const FilterLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[1]};
  font-weight: ${theme.typography.fontWeight.medium};
  color: ${theme.colors.text.primary};
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: ${theme.spacing[5]};
`;

export const TurmaCard = styled.div<{ ativa: boolean }>`
  background: ${theme.colors.background.primary};
  padding: ${theme.spacing[6]};
  border-radius: ${theme.borderRadius.xl};
  box-shadow: ${theme.shadows.md};
  transition: ${theme.transitions.normal};
  opacity: ${props => props.ativa ? 1 : 0.7};
  border-left: 4px solid ${props => props.ativa ? theme.colors.success[600] : theme.colors.error[600]};

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${theme.shadows.lg};
  }
`;

export const TurmaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: ${theme.spacing[4]};
`;

export const TurmaInfo = styled.div`
  flex: 1;
`;

export const TurmaTitle = styled.h3`
  margin: 0 0 ${theme.spacing[2]} 0;
  color: ${theme.colors.text.primary};
  font-size: ${theme.typography.fontSize.lg};
`;

export const TurmaSubtitle = styled.p`
  margin: 0;
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.sm};
`;

export const StatusBadge = styled.span<{ ativa: boolean }>`
  background: ${props => props.ativa ? theme.colors.success[100] : theme.colors.error[100]};
  color: ${props => props.ativa ? theme.colors.success[700] : theme.colors.error[700]};
  padding: ${theme.spacing[1]} ${theme.spacing[2]};
  border-radius: ${theme.borderRadius.base};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
  text-transform: uppercase;
`;

export const TurmaDetails = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${theme.spacing[3]};
  margin-bottom: ${theme.spacing[4]};
`;

export const DetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing[1]};
`;

export const DetailLabel = styled.span`
  color: ${theme.colors.text.secondary};
  font-size: ${theme.typography.fontSize.xs};
  font-weight: ${theme.typography.fontWeight.medium};
  text-transform: uppercase;
`;

export const DetailValue = styled.span`
  color: ${theme.colors.text.primary};
  font-weight: ${theme.typography.fontWeight.medium};
`;

export const StudentsInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  margin-bottom: ${theme.spacing[4]};
  padding: ${theme.spacing[3]};
  background: ${theme.colors.gray[50]};
  border-radius: ${theme.borderRadius.lg};
`;

export const StudentsCount = styled.span`
  font-weight: ${theme.typography.fontWeight.semibold};
  color: ${theme.colors.primary[600]};
`;

export const ActionButtons = styled.div`
  display: flex;
  gap: ${theme.spacing[2]};
  justify-content: flex-end;
`;

export const IconButton = styled.button<{ variant?: 'edit' | 'delete' | 'toggle' }>`
  padding: ${theme.spacing[2]};
  border: none;
  border-radius: ${theme.borderRadius.md};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: ${theme.transitions.normal};
  
  ${props => {
    switch (props.variant) {
      case 'edit':
        return `
          background: ${theme.colors.primary[100]};
          color: ${theme.colors.primary[700]};
          &:hover { background: ${theme.colors.primary[600]}; color: white; }
        `;
      case 'delete':
        return `
          background: ${theme.colors.error[100]};
          color: ${theme.colors.error[700]};
          &:hover { background: ${theme.colors.error[600]}; color: white; }
        `;
      case 'toggle':
        return `
          background: ${theme.colors.warning[100]};
          color: ${theme.colors.warning[700]};
          &:hover { background: ${theme.colors.warning[600]}; color: white; }
        `;
      default:
        return `
          background: ${theme.colors.gray[100]};
          color: ${theme.colors.text.secondary};
          &:hover { background: ${theme.colors.gray[200]}; }
        `;
    }
  }}
`;

export const EmptyIcon = styled.div`
  font-size: ${theme.typography.fontSize['3xl']};
  margin-bottom: ${theme.spacing[4]};
  opacity: 0.5;
`;
